module.exports = __webpack_public_path__ + "static/media/4021.4f2a4418.jpg";